<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content>

  <div class="spacer"></div>

  <button (click)="onSave()" color="primary" mat-button mat-raised-button>Save</button>
  <button (click)="showImportTable=!showImportTable;" *ifPrivilege="{name: 'read', value: 'imports'}" color="primary" mat-button
          mat-raised-button>Add/Remove Importer</button>
  <button (click)="showDetail=!showDetail;" color="primary" mat-button mat-raised-button>Edit Details</button>

  <div class="spacer"></div>
  <ng-container *ifPrivilege="{name: 'read', value: 'imports'}">
    <div *ngIf="showImportTable" class="split-wrapper">

      <mat-card appearance="outlined" class="split">
        <data-table
          (custom)="onCustomImportType($event)"
          [columns]="columnsImportType"
          [dataProvider]="importTypeService"
          [title]="'Filter ImportType'"
          [validator]="{ validate:'_id',  target: this.selectedId }"
          alternative_icon="clear"
          icon="keyboard_arrow_right"
          table_id="importType"
        ></data-table>
      </mat-card>

      <mat-card appearance="outlined" class="split">
        <data-table
          (custom)="onCustomImport($event)"
          [columns]="columnsImport"
          [dataProviderParams]="paramsImport"
          [dataProvider]="importService"
          [title]="'Choose Imports'"
          [validator]="{ validate:'_id',  target: this.customerImportIds }"
          alternative_icon="remove_circle"
          icon="add_circle"
          table_id="imports"
        ></data-table>
      </mat-card>

    </div>

  </ng-container>


  <div class="spacer"></div>

  <mat-card appearance="outlined" [ngClass]="{ 'show':showDetail }" class="hide">
    <mat-card-title>Details</mat-card-title>
    <div class="form-container">
      <ng-template formHost></ng-template>
    </div>
  </mat-card>

</page-content>
